import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("p", {
    class: ["mr-4 transition duration-150 ease-out-in", {
			'text-primary': _ctx.isSuccess,
			'text-danger': !_ctx.isSuccess,
			'opacity-0': !_ctx.show,
			'opacity-100': _ctx.show,
		}]
  }, _toDisplayString(_ctx.isSuccess ? 'Saved!' : 'Error'), 3))
}